(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["style-playground"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-sp]');
    if (!root) return;

    // optional gate: only show when URL has ?playground=1 (sticky per session)
    if (root.dataset.requireParam === 'true') {
      var GATE = 'sp-gate-open';
      var params = new URLSearchParams(location.search);
      if (params.get('playground') === '1') sessionStorage.setItem(GATE, '1');
      if (sessionStorage.getItem(GATE) !== '1') return;
    }

    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-sp-config]').textContent); } catch (e) { return; }

    // Clone the inert <template> into the DOM (kept out of static HTML so search
    // engines don't crawl the widget's text), then reveal.
    var tpl = root.querySelector('[data-sp-tpl]');
    if (!tpl || !('content' in tpl)) return;
    root.appendChild(tpl.content.cloneNode(true));
    root.hidden = false;

    var KEY = 'sp-style-choice';
    var HEAD_ORDER = ['default', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'h7'];
    var BODY_ORDER = ['default', 'b1', 'b2', 'b3', 'b4'];
    var html = document.documentElement;

    // Typography size sliders mirror the theme's two scales (percentages):
    //   bodyPct  -> --font-body-scale  (html rem base, drives body text)
    //   headingPct -> --font-heading-scale (= heading_scale / body_scale)
    var baseBody = cfg.bodyScale || 100;
    var baseHead = cfg.headingScale || 100;

    var glassDefault = cfg.glass === true ? 'on' : 'off';
    var state = { color: 'default', font: 'default', body: 'default', corners: 'default', glass: glassDefault,
                  bodyPct: baseBody, headingPct: baseHead };
    try { state = Object.assign(state, JSON.parse(localStorage.getItem(KEY) || '{}')); } catch (e) {}

    // Curated colour moods. Each palette = a dominant neutral + one sharp accent.
    // tones map to the theme's 4 scheme roles (light · surface · accent · dark);
    // 'accentOn' is the label colour used on accent/primary buttons. RGB triplets.
    var COLOR_PRESETS = [
      { key: 'rose', label: 'Rosé', accent: '156, 79, 91', accentOn: '253, 246, 244', tones: {
          light: { bg: '250, 244, 241', fg: '42, 33, 37' }, surface: { bg: '243, 231, 227', fg: '42, 33, 37' },
          accent: { bg: '156, 79, 91', fg: '253, 246, 244' }, dark: { bg: '42, 33, 37', fg: '250, 244, 241' } } },
      { key: 'sage', label: 'Sage', accent: '95, 116, 88', accentOn: '246, 248, 243', tones: {
          light: { bg: '244, 245, 239', fg: '35, 42, 32' }, surface: { bg: '230, 235, 224', fg: '35, 42, 32' },
          accent: { bg: '95, 116, 88', fg: '246, 248, 243' }, dark: { bg: '35, 42, 32', fg: '244, 245, 239' } } },
      { key: 'coral', label: 'Coral', accent: '224, 76, 38', accentOn: '42, 29, 23', tones: {
          light: { bg: '255, 246, 241', fg: '42, 29, 23' }, surface: { bg: '255, 232, 222', fg: '42, 29, 23' },
          accent: { bg: '224, 76, 38', fg: '42, 29, 23' }, dark: { bg: '42, 29, 23', fg: '255, 246, 241' } } },
      { key: 'ocean', label: 'Ocean', accent: '34, 100, 98', accentOn: '241, 248, 248', tones: {
          light: { bg: '241, 245, 246', fg: '24, 39, 45' }, surface: { bg: '224, 234, 236', fg: '24, 39, 45' },
          accent: { bg: '34, 100, 98', fg: '241, 248, 248' }, dark: { bg: '20, 36, 42', fg: '238, 245, 246' } } },
      { key: 'noir', label: 'Noir', accent: '192, 151, 47', accentOn: '22, 22, 22', tones: {
          light: { bg: '243, 241, 236', fg: '22, 22, 22' }, surface: { bg: '231, 227, 218', fg: '22, 22, 22' },
          accent: { bg: '192, 151, 47', fg: '22, 22, 22' }, dark: { bg: '18, 18, 18', fg: '239, 233, 221' } } },
      { key: 'bubblegum', label: 'Bubblegum', accent: '214, 46, 110', accentOn: '255, 244, 248', tones: {
          light: { bg: '255, 244, 248', fg: '42, 22, 32' }, surface: { bg: '255, 228, 238', fg: '42, 22, 32' },
          accent: { bg: '214, 46, 110', fg: '255, 244, 248' }, dark: { bg: '42, 22, 32', fg: '255, 244, 248' } } },
      { key: 'grape', label: 'Grape', accent: '109, 78, 214', accentOn: '247, 245, 252', tones: {
          light: { bg: '247, 245, 252', fg: '33, 27, 48' }, surface: { bg: '235, 230, 247', fg: '33, 27, 48' },
          accent: { bg: '109, 78, 214', fg: '247, 245, 252' }, dark: { bg: '27, 23, 38', fg: '247, 245, 252' } } },
      { key: 'cobalt', label: 'Cobalt', accent: '39, 82, 214', accentOn: '244, 246, 252', tones: {
          light: { bg: '244, 246, 252', fg: '19, 26, 46' }, surface: { bg: '226, 232, 248', fg: '19, 26, 46' },
          accent: { bg: '39, 82, 214', fg: '244, 246, 252' }, dark: { bg: '16, 22, 40', fg: '238, 242, 251' } } }
    ];
    var SCHEME_ROLES = ['light', 'surface', 'accent', 'dark'];

    function presetByKey(k) {
      for (var i = 0; i < COLOR_PRESETS.length; i++) if (COLOR_PRESETS[i].key === k) return COLOR_PRESETS[i];
      return null;
    }

    // Homepage (and most) sections set their OWN colours as section-scoped CSS
    // vars (#shopify-section-x { --color-background: ... }), so the scheme/root
    // override alone can't reach them. We capture each section's original bg once
    // and re-map it to the matching preset tone via inline !important overrides —
    // preserving the light/dark/accent rhythm rather than flattening everything.
    var SECTIONS = [].slice.call(document.querySelectorAll('[id^="shopify-section-"]'));
    var SECTION_ORIG = SECTIONS.map(function (el) {
      return getComputedStyle(el).getPropertyValue('--color-background').trim();
    });
    var SECTION_PROPS = ['--color-background', '--color-foreground', '--color-heading', '--color-shadow',
      '--color-button-background', '--color-button-border', '--color-button-text', '--color-highlight'];
    var themeAccentNorm = (cfg.themeAccent || '').replace(/\s+/g, '');
    function toneRole(rgb) {
      if (!rgb) return 'light';
      if (rgb.replace(/\s+/g, '') === themeAccentNorm) return 'accent';
      var p = rgb.split(',').map(function (n) { return parseInt(n, 10) || 0; });
      var lum = (0.299 * p[0] + 0.587 * p[1] + 0.114 * p[2]) / 255;
      return lum < 0.42 ? 'dark' : 'light';
    }
    function mix(a, b, t) { // blend two "R, G, B" triplets, t in [0,1]
      var pa = a.split(',').map(Number), pb = b.split(',').map(Number);
      return pa.map(function (v, i) { return Math.round(v + (pb[i] - v) * t); }).join(', ');
    }
    function toHex(rgb) {
      return '#' + rgb.split(',').map(function (n) {
        var h = (parseInt(n, 10) || 0).toString(16); return h.length < 2 ? '0' + h : h;
      }).join('');
    }
    // Dual-scroll fades its sticky media bg between each block's data-media-bg-color
    // (JS reads it as HEX). Capture originals so a preset can hand each block a
    // distinct on-tone HEX (light → richer accent) and keep the scroll colour fade.
    var DS_PANELS = [].slice.call(document.querySelectorAll('.dual-scroll-panel'));
    var DS_ORIG = DS_PANELS.map(function (el) { return el.getAttribute('data-media-bg-color'); });
    var DS_VIEWPORTS = [].slice.call(document.querySelectorAll('.dual-scroll-media-viewport'));
    var DS_RATIOS = [0.1, 0.24, 0.42, 0.6, 0.3, 0.16];

    // Recolour by (1) injecting a <style> for scheme classes + base vars, and
    // (2) re-mapping each section's own colours inline.
    var colorStyle = null;
    function applyColors() {
      var p = presetByKey(state.color);

      // (1) global scheme + base vars
      if (!p) {
        if (colorStyle) colorStyle.textContent = '';
        // restore dual-scroll's original per-block colours + let JS drive the viewport
        DS_PANELS.forEach(function (el, i) {
          if (DS_ORIG[i] == null) el.removeAttribute('data-media-bg-color');
          else el.setAttribute('data-media-bg-color', DS_ORIG[i]);
        });
        DS_VIEWPORTS.forEach(function (v) { v.style.removeProperty('background-color'); });
      }
      else {
        if (!colorStyle) { colorStyle = document.createElement('style'); colorStyle.id = 'sp-colors'; document.head.appendChild(colorStyle); }
        var block = function (t) {
          return '--color-background:' + t.bg + ';--color-foreground:' + t.fg + ';--color-heading:' + t.fg +
                 ';--color-link:' + t.fg + ';--color-button:' + t.fg + ';--color-button-text:' + t.bg +
                 ';--color-shadow:' + t.fg + ';';
        };
        var css = '';
        (cfg.schemes || []).forEach(function (id, i) {
          var t = p.tones[SCHEME_ROLES[Math.min(i, SCHEME_ROLES.length - 1)]];
          css += '.color-' + id + '{' + block(t) + '}';
        });
        css += ':root{--color-base-accent:' + p.accent + ';--color-base-background:' + p.tones.light.bg +
               ';--color-base-text:' + p.tones.light.fg + ';--color-base-heading:' + p.tones.light.fg +
               ';--color-base-solid-button-labels:' + p.accentOn + ';--color-base-outline-button-labels:' + p.tones.light.fg +
               ';--color-placeholder:' + p.tones.surface.bg + ';}';
        // Sections that bake backgrounds as literal inline colours (not CSS vars)
        // need a targeted !important override to join the preset tone. Soft
        // backdrops (cards / media panels) map to the surface tone.
        var s = p.tones.surface, lf = p.tones.light.fg;
        css +=
          // Multicolumn: card backdrop + per-block title/text colours.
          '.multicolumn-card{background-color:rgb(' + s.bg + ')!important}' +
          '.multicolumn-card__title,.multicolumn-card .rte,.multicolumn-popup__text{color:rgb(' + lf + ')!important}' +
          // Dual-scroll: panel box backdrop + per-block highlight.
          '.dual-scroll-panel{background:rgb(' + s.bg + ')!important;--color-highlight:' + p.accent + '!important}' +
          // Dual-scroll: text + buttons follow the tone (its own scoped vars).
          '[id^=dual-scroll-]{--color-text:rgb(' + lf + ')!important;--color-muted:rgba(' + lf + ',.72)!important;' +
          '--color-foreground:' + lf + '!important;--color-heading:' + lf + '!important;' +
          '--color-button-background:' + p.accent + '!important;--color-button-border:' + p.accent + '!important;--color-button-text:' + p.accentOn + '!important}';

        // Dual-scroll media: give each block a distinct on-tone HEX so the scroll
        // colour-fade is preserved (light → progressively richer accent tint).
        DS_PANELS.forEach(function (el, i) {
          var hex = toHex(mix(p.tones.light.bg, p.accent, DS_RATIOS[i % DS_RATIOS.length]));
          el.setAttribute('data-media-bg-color', hex);
          css += '.dual-scroll-panel:nth-of-type(' + (i + 1) + ') .dual-scroll-panel__media{background-color:' + hex + '!important}';
        });
        // seed the sticky viewport with the first block's colour (non-important so
        // the component's JS can keep fading between blocks on scroll)
        if (DS_VIEWPORTS.length) {
          var firstHex = toHex(mix(p.tones.light.bg, p.accent, DS_RATIOS[0]));
          DS_VIEWPORTS.forEach(function (v) { v.style.backgroundColor = firstHex; });
        }
        colorStyle.textContent = css;
      }

      // (2) per-section inline override (covers homepage hardcoded colours)
      SECTIONS.forEach(function (el, i) {
        if (!p) { SECTION_PROPS.forEach(function (prop) { el.style.removeProperty(prop); }); return; }
        var t = p.tones[toneRole(SECTION_ORIG[i])];
        el.style.setProperty('--color-background', t.bg, 'important');
        el.style.setProperty('--color-foreground', t.fg, 'important');
        el.style.setProperty('--color-heading', t.fg, 'important');
        el.style.setProperty('--color-shadow', t.fg, 'important');
        el.style.setProperty('--color-button-background', p.accent, 'important');
        el.style.setProperty('--color-button-border', p.accent, 'important');
        el.style.setProperty('--color-button-text', p.accentOn, 'important');
        el.style.setProperty('--color-highlight', p.accent, 'important');
      });
    }

    // Build the colour row: Default + presets, each with an accent swatch.
    function buildColorRow() {
      var grp = root.querySelector('[data-sp-color]');
      if (!grp) return;
      var items = [{ key: 'default', label: 'Default', sw: cfg.themeAccent }];
      COLOR_PRESETS.forEach(function (p) { items.push({ key: p.key, label: p.label, sw: p.accent }); });
      items.forEach(function (it) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp__opt sp__opt--color';
        b.dataset.val = it.key;
        b.setAttribute('aria-pressed', String(it.key === state.color));
        var sw = document.createElement('span');
        sw.className = 'sp__swatch';
        sw.style.background = 'rgb(' + it.sw + ')';
        b.appendChild(sw);
        b.appendChild(document.createTextNode(it.label));
        grp.appendChild(b);
      });
    }

    // Build a button row from a config map ({id: "Family, stack"}) in a fixed order.
    // The label is the family name (first token of the stack, quotes stripped).
    function buildRow(sel, order, map) {
      var grp = root.querySelector(sel);
      if (!grp) return;
      order.forEach(function (id) {
        var stack = map[id];
        if (!stack) return; // slot left empty in the editor → skip
        var label = stack.split(',')[0].replace(/["']/g, '').trim();
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sp__opt sp__opt--font';
        b.dataset.val = id;
        b.setAttribute('aria-pressed', 'false');
        b.textContent = label;
        b.style.fontFamily = stack; // preview: render each name in its own font
        grp.appendChild(b);
      });
    }
    buildColorRow();
    buildRow('[data-sp-font]', HEAD_ORDER, cfg.headings);
    buildRow('[data-sp-body]', BODY_ORDER, cfg.bodies);

    function allowedBodies() { return cfg.pairs[state.font] || ['default']; }

    // Filter the body row to the current heading's allowed fonts, snapping the
    // selection to the first allowed option if the current one isn't valid.
    function enforcePairing() {
      var allowed = allowedBodies();
      if (allowed.indexOf(state.body) === -1) state.body = allowed[0];
      var grp = root.querySelector('[data-sp-body]');
      if (!grp) return;
      grp.querySelectorAll('.sp__opt').forEach(function (b) {
        b.hidden = allowed.indexOf(b.dataset.val) === -1;
      });
    }

    function apply() {
      // heading font — fall back to theme default if the slot is empty/missing
      // (avoids writing the literal string "undefined" into the CSS variable)
      if (state.font === 'default' || !cfg.headings[state.font]) {
        html.style.removeProperty('--font-heading-family');
      } else {
        html.style.setProperty('--font-heading-family', cfg.headings[state.font]);
      }
      // body font (constrained to the heading's allowed pairings)
      if (state.body === 'default' || !cfg.bodies[state.body]) {
        html.style.removeProperty('--font-body-family');
      } else {
        html.style.setProperty('--font-body-family', cfg.bodies[state.body]);
      }
      // typography size — body scale drives the html rem base; heading scale
      // tunes headings relative to body (theme convention: heading/body ratio)
      if (state.bodyPct === baseBody) html.style.removeProperty('--font-body-scale');
      else html.style.setProperty('--font-body-scale', state.bodyPct / 100);
      if (state.bodyPct === baseBody && state.headingPct === baseHead) html.style.removeProperty('--font-heading-scale');
      else html.style.setProperty('--font-heading-scale', state.headingPct / state.bodyPct);
      // corners
      if (state.corners === 'default') {
        html.style.setProperty('--button-radius', cfg.radiusBtn + 'px');
        html.style.setProperty('--card-radius', cfg.radiusCard + 'px');
      } else if (state.corners === 'soft') {
        html.style.setProperty('--button-radius', '8px');
        html.style.setProperty('--card-radius', '12px');
      } else { // round
        html.style.setProperty('--button-radius', '999px');
        html.style.setProperty('--card-radius', '16px');
      }
      // glass — toggle the REAL theme class so it matches Theme settings
      document.body.classList.toggle('glass-enabled', state.glass === 'on');
      refreshReset();
    }

    // Reset only shows once the visitor has changed something away from theme.
    var resetBtn = root.querySelector('[data-sp-reset]');
    function isDirty() {
      return state.color !== 'default' || state.font !== 'default' || state.body !== 'default' ||
             state.corners !== 'default' || state.glass !== glassDefault ||
             state.bodyPct !== baseBody || state.headingPct !== baseHead;
    }
    function refreshReset() { if (resetBtn) resetBtn.hidden = !isDirty(); }

    var GROUPS = [['[data-sp-color]', 'color'], ['[data-sp-font]', 'font'], ['[data-sp-body]', 'body'], ['[data-sp-corners]', 'corners'], ['[data-sp-glass]', 'glass']];

    // Typography sliders (separate from the button GROUPS).
    var sizeSlider = root.querySelector('[data-sp-size]');
    var headSlider = root.querySelector('[data-sp-head]');
    var sizeVal = root.querySelector('[data-sp-size-val]');
    var headVal = root.querySelector('[data-sp-head-val]');
    function syncSliders() {
      if (sizeSlider) { sizeSlider.value = state.bodyPct; if (sizeVal) sizeVal.textContent = state.bodyPct + '%'; }
      if (headSlider) { headSlider.value = state.headingPct; if (headVal) headVal.textContent = state.headingPct + '%'; }
    }
    if (sizeSlider) sizeSlider.addEventListener('input', function () {
      state.bodyPct = parseInt(sizeSlider.value, 10) || baseBody;
      if (sizeVal) sizeVal.textContent = state.bodyPct + '%';
      apply(); save();
    });
    if (headSlider) headSlider.addEventListener('input', function () {
      state.headingPct = parseInt(headSlider.value, 10) || baseHead;
      if (headVal) headVal.textContent = state.headingPct + '%';
      apply(); save();
    });

    function syncButtons() {
      GROUPS.forEach(function (pair) {
        var grp = root.querySelector(pair[0]);
        if (!grp) return;
        grp.querySelectorAll('.sp__opt').forEach(function (b) {
          b.setAttribute('aria-pressed', String(b.dataset.val === state[pair[1]]));
        });
      });
    }

    function save() { try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }

    GROUPS.forEach(function (pair) {
        var grp = root.querySelector(pair[0]);
        if (!grp) return;
        grp.addEventListener('click', function (e) {
          var btn = e.target.closest('.sp__opt'); if (!btn || btn.hidden) return;
          state[pair[1]] = btn.dataset.val;
          if (pair[1] === 'font') enforcePairing(); // changing heading may re-snap body
          if (pair[1] === 'color') applyColors();
          apply(); syncButtons(); save();
        });
      });

    var toggle = root.querySelector('[data-sp-toggle]');
    function setOpen(open) {
      root.classList.toggle('open', open);
      toggle.setAttribute('aria-expanded', String(open));
    }
    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      setOpen(!root.classList.contains('open'));
    });

    // Close when tapping/clicking outside the widget, or pressing Escape.
    document.addEventListener('click', function (e) {
      if (root.classList.contains('open') && !root.contains(e.target)) setOpen(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('open')) {
        setOpen(false);
        toggle.focus();
      }
    });

    // Minimize: hide the "Try the look" pill, leave a small handle to restore it.
    var MIN_KEY = 'sp-minimized';
    var dismiss = root.querySelector('[data-sp-dismiss]');
    var handle = root.querySelector('[data-sp-handle]');
    function setMinimized(min) {
      root.classList.toggle('minimized', min);
      if (min) setOpen(false);
      try { localStorage.setItem(MIN_KEY, min ? '1' : '0'); } catch (e) {}
    }
    if (dismiss) dismiss.addEventListener('click', function (e) {
      e.stopPropagation(); setMinimized(true); if (handle) handle.focus();
    });
    if (handle) handle.addEventListener('click', function (e) {
      e.stopPropagation(); setMinimized(false); toggle.focus();
    });
    try { if (localStorage.getItem(MIN_KEY) === '1') root.classList.add('minimized'); } catch (e) {}

    root.querySelector('[data-sp-reset]').addEventListener('click', function () {
      state = { color: 'default', font: 'default', body: 'default', corners: 'default', glass: glassDefault,
                bodyPct: baseBody, headingPct: baseHead };
      enforcePairing(); applyColors(); apply(); syncButtons(); syncSliders(); save();
    });

    // Ride the mobile dock: measure how much of it is on screen into
    // --sp-dock-offset. The dock slides via transform for several
    // independent reasons (scroll threshold, sticky-header state, open
    // overlays), so its real edge is the only reliable signal — an rAF
    // loop runs only while its transform transitions, keeping the pill
    // on the same frames the dock animates through.
    var dock = document.querySelector('.mobile-dock');
    if (dock) {
      var dockRaf = null;
      var applyDockOffset = function () {
        var visible = Math.max(0, window.innerHeight - dock.getBoundingClientRect().top);
        root.style.setProperty('--sp-dock-offset', Math.round(visible) + 'px');
      };
      var followDock = function () {
        applyDockOffset();
        dockRaf = requestAnimationFrame(followDock);
      };
      var stopFollowDock = function () {
        if (dockRaf) cancelAnimationFrame(dockRaf);
        dockRaf = null;
        applyDockOffset();
      };
      dock.addEventListener('transitionrun', function (e) {
        if (e.target === dock && !dockRaf) followDock();
      });
      dock.addEventListener('transitionend', function (e) {
        if (e.target === dock) stopFollowDock();
      });
      dock.addEventListener('transitioncancel', function (e) {
        if (e.target === dock) stopFollowDock();
      });
      window.addEventListener('resize', applyDockOffset);
      applyDockOffset();
    }

    enforcePairing(); applyColors(); apply(); syncButtons(); syncSliders();
  })();

  } catch(e) { console.error(e); }
})();
})();
